import React, { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useFeaturesLoyaltyTiersContent } from 'state/loyalty/hooks/use-feature-loyalty-tiers-content';

import {
  HeaderContainer,
  HowItWorksButton,
  StyledLoyaltyTiersLogo,
  StyledPicture,
  UnauthCellContainer,
  UnauthCellDescription,
  UnauthCellDetails,
  UnauthCellTitle,
  UnauthTile,
  UnauthenticatedTierContainer,
} from './styled';

interface ILoyaltyTiersUnauthenticatedBannerProps {
  hideActionButton?: boolean;
}

const UnauthenticatedTierBanner: FC<ILoyaltyTiersUnauthenticatedBannerProps> = ({
  hideActionButton,
}) => {
  const navigate = useNavigate();
  const { loading, data } = useFeaturesLoyaltyTiersContent();

  const handleClick = () => {
    navigate(data?.loyaltyTiersHowItWorksButtonLink?.locale!);
  };

  return (
    <UnauthenticatedTierContainer data-testid="unauthenticated-tier-banner">
      <HeaderContainer>
        <StyledLoyaltyTiersLogo center={hideActionButton} />
        {!loading && !hideActionButton && (
          <HowItWorksButton
            size={ActionButtonSizes.SMALL}
            data-testid="unauthenticated-tier-banner-how-it-works-button"
            variant={ActionButtonVariants.OUTLINE}
            onClick={handleClick}
          >
            {data?.loyaltyTiersHowItWorksButtonText?.locale}
          </HowItWorksButton>
        )}
      </HeaderContainer>
      {!loading && (
        <>
          <UnauthCellContainer fullRows={hideActionButton}>
            {data?.loyaltyTiersUnauthenticatedCells?.map((tile, id) => (
              <UnauthTile key={id} fullRow={hideActionButton}>
                <StyledPicture
                  image={tile?.loyaltyTiersSignupCellImage?.locale}
                  alt=""
                  objectFitContain
                />
                <UnauthCellDetails>
                  <UnauthCellTitle>{tile?.loyaltyTiersSignupCellTitle?.locale}</UnauthCellTitle>
                  <UnauthCellDescription>
                    {tile?.loyaltyTiersSignupCellDescription?.locale}
                  </UnauthCellDescription>
                </UnauthCellDetails>
              </UnauthTile>
            ))}
          </UnauthCellContainer>
        </>
      )}
    </UnauthenticatedTierContainer>
  );
};

export default UnauthenticatedTierBanner;
